<script>
    import {router} from '../lib/Router/Router.svelte';
    import A from "../lib/Router/A.svelte";
    import {createEventDispatcher} from 'svelte/internal';

    export let breadcrumb = [];

    const dispatch = createEventDispatcher();

    const triggerEvent = (event) => {
        dispatch(event);
    }
</script>


<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        {#each breadcrumb as item}
            <li class="breadcrumb-item">
                {#if item.link}
                    <A href="{ item.link }">{ item.name }</A>
                {:else}
                    <a href="#" on:click|preventDefault="{ () => triggerEvent(item.id) }">{ item.name }</a>
                {/if}
            </li>
        {/each}
    </ol>
</nav>

<style>
    .breadcrumb-item {
        font-size: 0.94rem;
    }
</style>